// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"41":"email","321":"core","493":"security","544":"preferences","685":"error"}[chunkId] || chunkId) + "." + {"41":"609ae79a","321":"7ecf2077","493":"e67a0c3f","544":"746cb35e","549":"6eae7e29","685":"dcef1637"}[chunkId] + ".js";
};